export default __webpack_public_path__ + "locales/uk-UA/PortalUnavailable.json?hash=2ed7284e4f2ec72d4c1692fe4cf373d1";